import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'
import { StateProvince } from 'Core/utils/storeHelpers/types'

export enum DisposalFacilitiesSearchFields {
	disposalFacilityName = 'disposalFacilityName',
	supplierLocationId = 'supplierLocationId',
	supplierLocationName = 'supplierLocationName',
	supplierId = 'supplierId',
	supplierName = 'supplierName'
}

export enum DisposalFacilitiesFilterFields {
	includeInactive = 'includeInactive',
	includeInactiveSupplierLocation = 'includeInactiveSupplierLocation'
}

export declare namespace DisposalFacility {
	interface Basic extends Entity {
		epaId: string | null
		isActive: boolean
		isDefault: boolean
		supplierId: number
		supplierName: string
		supplierActive: boolean
		supplierLocationId: number
		supplierLocationName: string
		supplierLocationActive: boolean
		supplierLocationCity: string
		supplierLocationState: string
		stateRegId: string
		isTurkish: boolean
	}

	namespace Address {
		interface Basic {
			id: number
			addressType: Entity | null
			addressLine1: BasicString
			addressLine2: BasicString
			zip: BasicString
			city: BasicString
			state: StateProvince | null
			isActive: boolean
			latitude: BasicNumber
			longitude: BasicNumber
		}
		namespace Form {
			interface Generic {
				addressTypeId: BasicNumber
				addressLine1: BasicString
				addressLine2: BasicString
				zipCode: BasicString
				city: BasicString
				stateProvinceId: LabelValueExtra | null
				isActive: boolean
				latitude: BasicNumber
				longitude: BasicNumber
			}
		}

		namespace Request {
			interface Generic {
				addressTypeId: BasicNumber
				addressLine1: BasicString
				addressLine2: BasicString
				zip: BasicString
				city: BasicString
				stateId: BasicNumber
				isActive: boolean
				latitude: BasicNumber
				longitude: BasicNumber
			}

			interface Add extends Generic {}
			interface Edit extends Generic {}
		}
	}

	type ListForSupplierLocation = Pick<Basic, 'id' | 'name' | 'isDefault' | 'isActive'>

	interface Form extends Pick<Basic, 'name' | 'isDefault' | 'epaId' | 'isActive' | 'stateRegId'> {
		supplierLocationId: LabelValue<number> | null
	}

	interface Request extends Omit<Form, 'supplierLocationId'> {
		supplierLocationId: Key | null
	}

	namespace Search {
		interface Config {
			[DisposalFacilitiesSearchFields.disposalFacilityName]: ConfigItem<DisposalFacilitiesSearchFields>
			[DisposalFacilitiesSearchFields.supplierLocationId]: ConfigItem<DisposalFacilitiesSearchFields>
			[DisposalFacilitiesSearchFields.supplierLocationName]: ConfigItem<DisposalFacilitiesSearchFields>
			[DisposalFacilitiesSearchFields.supplierId]: ConfigItem<DisposalFacilitiesSearchFields>
			[DisposalFacilitiesSearchFields.supplierName]: ConfigItem<DisposalFacilitiesSearchFields>
		}

		interface Result {
			[DisposalFacilitiesSearchFields.disposalFacilityName]: string[]
			[DisposalFacilitiesSearchFields.supplierLocationId]: Entity[]
			[DisposalFacilitiesSearchFields.supplierLocationName]: Entity[]
			[DisposalFacilitiesSearchFields.supplierId]: Entity[]
			[DisposalFacilitiesSearchFields.supplierName]: Entity[]
		}
	}

	namespace Filter {
		interface Config {
			[DisposalFacilitiesFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
			[DisposalFacilitiesFilterFields.includeInactiveSupplierLocation]: ConfigFilterItem<
				string,
				boolean
			>
		}
	}
}
